/**
 * BrandMark — the HandInvoice signal-rings logo.
 *
 * Yellow center dot with two concentric outline rings at decreasing
 * opacity (0.55, 0.25). Replaces the legacy single-yellow-dot prefix on
 * page wordmarks.
 *
 * Size variants follow the rebrand spec:
 *   header  (~20px): inner r=4,  ring1 r=9  / 1.2,  ring2 r=14 / 1.2
 *   standard(~40px): inner r=7,  ring1 r=15 / 1.5,  ring2 r=23 / 1.5
 *   large   (~128px):inner r=20, ring1 r=44 / 3,    ring2 r=68 / 3
 */
const YELLOW = "#e8dc2d";

const SIZES = {
  header:   { box: 30, inner: 4,  r1: 9,  r2: 14, sw: 1.2 },
  standard: { box: 50, inner: 7,  r1: 15, r2: 23, sw: 1.5 },
  large:    { box: 140, inner: 20, r1: 44, r2: 68, sw: 3   },
};

export default function BrandMark({ size = "header", testId }) {
  const s = SIZES[size] || SIZES.header;
  const half = s.box / 2;
  return (
    <svg
      data-testid={testId}
      viewBox={`-${half} -${half} ${s.box} ${s.box}`}
      width={s.box}
      height={s.box}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      style={{ display: "inline-block", flexShrink: 0 }}
    >
      <circle cx="0" cy="0" r={s.inner} fill={YELLOW} />
      <circle cx="0" cy="0" r={s.r1} fill="none" stroke={YELLOW} strokeWidth={s.sw} opacity="0.55" />
      <circle cx="0" cy="0" r={s.r2} fill="none" stroke={YELLOW} strokeWidth={s.sw} opacity="0.25" />
    </svg>
  );
}
